import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import { MinusSmIcon, PlusSmIcon } from "@heroicons/react/outline";

interface Specification {
  COLUMN1: string;
  COLUMN2: string;
}

interface ProductSpecificationsProps {
  specifications: Specification[];
  productName: string;
}

export const ProductSpecifications = ({ specifications, productName }: ProductSpecificationsProps) => {
  if (!specifications) return null;

  return (
    <Disclosure as="div" key={productName}>
      {({ open }) => (
        <>
          <h3>
            <DisclosureButton className="group relative w-full py-6 flex justify-between items-center text-left">
              <span className={`${open ? "text-indigo-600" : "text-gray-900"} text-lg font-medium`}>
                Specifications
              </span>
              <span className="ml-6 flex items-center">
                {open ? (
                  <MinusSmIcon
                    className="block h-6 w-6 text-indigo-400 group-hover:text-indigo-500"
                    aria-hidden="true"
                  />
                ) : (
                  <PlusSmIcon
                    className="block h-6 w-6 text-gray-400 group-hover:text-gray-500"
                    aria-hidden="true"
                  />
                )}
              </span>
            </DisclosureButton>
          </h3>
          <DisclosurePanel as="div" className="pb-6 prose prose-sm max-w-full">
            {specifications.map((spec, i) => (
              <div
                key={i}
                className="mt-8 sm:grid sm:mt-5 sm:grid-cols-3 sm:gap-4 sm:border-t sm:border-gray-200 sm:pt-5"
              >
                <dt className="text-sm leading-5 font-medium text-gray-500">
                  {spec.COLUMN1}
                </dt>
                <dd className="mt-1 text-sm leading-5 text-gray-900 sm:mt-0 sm:col-span-2">
                  {spec.COLUMN2}
                </dd>
              </div>
            ))}
          </DisclosurePanel>
        </>
      )}
    </Disclosure>
  );
};